import { AliLogTracker } from './ali-log-tracker';
import { DeviceInfo } from './../../model/device-info/device-info';
import { Injectable } from '@angular/core';
import { User } from './../../model/user/user';


@Injectable()
export class NecErrorCollectService {
  logger: AliLogTracker;
  deviceInfo: DeviceInfo;
  userInfo: User;
  inited: boolean;

  constructor() {
    let url = window.location.host;
    let logProject = 'frontend-log';
    let logStore = '-mgt-web';
    let env = 'local';

    if (url.indexOf('512ks') >= 0) {
      if (url.indexOf('dev') >= 0) {
        env = 'dev';
      } else if (url.indexOf('rls') >= 0) {
        env = 'rls';
      } else if (url.indexOf('hfx') >= 0) {
        env = 'hfx';
      } else if (url.indexOf('www') >= 0) {
        env = 'prd';
      }
    }

    if (url.indexOf('admin') >= 0) {
      logStore = '-admin';
    }

    if (env !== 'local' && logProject) {
      this.logger = new AliLogTracker(
        'cn-hangzhou.log.aliyuncs.com',
        logProject,
        'nec-' + env + logStore
      );
    }

    this.deviceInfo = new DeviceInfo();
    this.inited = false;
  }

  init(userInfo: User) {
    if (!this.inited && userInfo) {
      this.inited = true;
      this.userInfo = userInfo;
    }
  }

  clear() {
    this.inited = false;
    this.userInfo = null;
  }

  sendLog(err: any) {
    if (this.logger) {
      if (this.userInfo) {
        this.logger.push('userId', this.userInfo.me.id);
        this.logger.push('tenant', this.userInfo.tenant.name);
        this.logger.push('phoneNum', this.userInfo.me.phoneNum);
      }

      this.logger.push('timestamp', new Date().getTime());
      this.logger.push('userAgent', this.deviceInfo.userAgent);
      this.logger.push('browser', this.deviceInfo.browser);
      this.logger.push('screen', this.deviceInfo.screen);
      if (typeof err === 'string') {
        this.logger.push('errorStack', err);
      } else {
        this.logger.push('errorMsg', decodeURIComponent(err.message));
        this.logger.push('errorStack', decodeURIComponent(err.stack));
      }

      // mobileç«¯é¢å¤æ°æ®
      this.logger.push('weChatVersion', this.deviceInfo.weChatVersion);
      this.logger.push('platform', this.deviceInfo.platform);
      this.logger.push('system', this.deviceInfo.system);

      // åélogä¿¡æ¯
      this.logger.logger();
    }
  }
}
